import { CustomDate } from "app/common/components/CustomDate";
import moment from "moment";

export const currentYear = new Date().getFullYear();

export const currentMonth = new Date().getMonth() + 1;

export const dateIsBefore = moment(moment().format()).isBefore(moment(`${currentMonth >= 4 ? currentYear + 1 : currentYear}-04-01T00:00:00.000Z`));

export const currentFiscalYear = currentMonth >= 4 ? currentYear : currentYear - 1;

export const get30Days = () => {
    const today = new Date();
    const thirtyDaysAgo = today.getTime() - 30 * 24 * 60 * 60 * 1000;
    const { dmyDate: endDate } = thirtyDaysAgo ? CustomDate(thirtyDaysAgo) : "-"
    const { dmyDate: newDate } = today ? CustomDate(today) : "-"
    return { fromDate: endDate, toDate: newDate }
}

export const reduceDays = (date, count) => date - (24 * 60 * 60 * 1000) * count